import { render, staticRenderFns } from "./CardFooterItem.vue?vue&type=template&id=6ba0052e&functional=true&"
import script from "./CardFooterItem.vue?vue&type=script&lang=js&"
export * from "./CardFooterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports